import { createMirror, removeObjectFromCanvas, removeRepeatingLinkParams } from '@frontend/utils';
import { UPLOAD_BACKGROUND_IMAGE_PREFIX_ID } from '@frontend/constants/templates-field-prefixes';
import { ShowPageScopeCollector } from '@frontend/group/modules/scope-collectors/show-page-collector';
import { fabric } from 'fabric';
import { getGroupNameByAddFieldId } from "@/common/preview/draw-smart-object";
import { FIELD_TYPE_SMART_OBJECT } from "@frontend/constants/type-fields-of-template";

const getScopePage = () => ShowPageScopeCollector.get(['canvas_data', 'getIsLightweight']);

export function drawUploadedBackgroundImage({ canvas, data, fields, id }) {
  removeObjectFromCanvas(canvas, UPLOAD_BACKGROUND_IMAGE_PREFIX_ID);
  const instanceId = id;
  const { canvas_data, getIsLightweight } = getScopePage();
  const is_lightweight = getIsLightweight();
  
  fields.forEach((field, index) => {
    if (field.type === 'Background Image Upload') {
      const options = JSON.parse(field.options);
      canvas_data[instanceId].uploaded_image[field.element_id] = options;
      const elementId = field.element_id;
      const groupName = getGroupNameByAddFieldId(
        String(field.id),
        canvas_data[id]
      );
      const order = options['Order'] ? options['Order'] : 1000;

      let url;
      const img = document.getElementsByName(elementId)[0];
      if (img?.files?.length) {
        url = URL.createObjectURL(img.files[0]);
      } else {
        url = $(`#${elementId}_saved`).val();
      }

      // replace domain name from URL POR-2222
      if (url && url.includes('share?file=')) {
        url = removeRepeatingLinkParams(url, '&full_resolution');
      }

      fabric.Image.fromURL(url, async function (oImg) {
        let r = oImg.width / parseInt(options.Width);
        let r1 = oImg.height / r / parseInt(options.Height);
        
        oImg.set({
          id: UPLOAD_BACKGROUND_IMAGE_PREFIX_ID + index,
          fieldType: field.type,
          element_id: elementId,
          groupName: groupName,
          order: order,
          left: parseInt(options.X),
          top: parseInt(options.Y),
        });
        
        oImg.scaleToWidth(oImg.width / r / r1);
        oImg.scaleToHeight(oImg.height / r / r1);
        
        canvas.add(oImg);
        
        const isMirror = data[`${elementId}_is_mirror`] && data[`${elementId}_is_mirror`] === 'true';
        
        if (isMirror) {
          await createMirror(oImg, elementId, canvas, data)
            .then(() => {
              canvas.remove(oImg);
            });
        }
      });
    }
  });
}
